<template>
  <div class="task-single">
    <template v-if="task">
      <div id="taskHeader" class="task-header">
        <a href="javascript:history.back();">
          <svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="arrow-left" class="svg-inline--fa fa-arrow-left fa-w-14"
               role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">
            <path fill="currentColor" d="M257.5 445.1l-22.2 22.2c-9.4 9.4-24.6 9.4-33.9 0L7 273c-9.4-9.4-9.4-24.6 0-33.9L201.4
              44.7c9.4-9.4 24.6-9.4 33.9 0l22.2 22.2c9.5 9.5 9.3 25-.4 34.3L136.6 216H424c13.3 0 24 10.7 24 24v32c0 13.3-10.7 24-24
              24H136.6l120.5 114.8c9.8 9.3 10 24.8.4 34.3z"></path>
          </svg>
          Back
        </a>
        <div class="form-element tasks-list-admin-header-companies" v-if="isAdmin">
          <label for="companiesList">Change company</label>
          <v-select class="form-control form-control__select tasks-list-header-boards-selector"
                    @change="changeCompany($event)"
                    :options="companies"
                    :searchable="true"
                    :clearable="false"
                    :value="this.currentCompany"
                    name="companiesList"
                    id="companiesList"/>
        </div>
      </div>
      <div class="task-single-header">
        <div class="task-single-header-content-type" :class="[ 'content-type-' + task.contentType ]">
          <!--<img :src="contentTypeById(task.contentType).icon" />-->
          <template v-if="task.contentType === 7">
            <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                 viewBox="0 0 32 32" style="enable-background:new 0 0 32 32;" xml:space="preserve">
            <g>
              <circle class="st0" cx="16" cy="16" r="16"/>
              <path id="play" class="st1" d="M20.068,15.367l-6.188-3.762c-0.408-0.226-0.922-0.079-1.149,0.329
                c-0.069,0.125-0.106,0.266-0.106,0.409v7.313c0.001,0.467,0.381,0.845,0.849,0.843c0.142,0,0.282-0.037,0.406-0.105l6.188-3.55
                c0.408-0.228,0.554-0.743,0.326-1.151C20.317,15.556,20.205,15.443,20.068,15.367z M24.719,16c0.001-4.814-3.901-8.718-8.715-8.719
                c-0.001,0-0.003,0-0.004,0c-4.814-0.001-8.718,3.901-8.719,8.715c0,0.001,0,0.003,0,0.004c-0.001,4.814,3.901,8.718,8.715,8.719
                c0.001,0,0.003,0,0.004,0c4.814,0.001,8.718-3.901,8.719-8.715C24.719,16.003,24.719,16.001,24.719,16z M8.969,16
                c-0.001-3.882,3.145-7.03,7.027-7.031c0.001,0,0.003,0,0.004,0c3.882-0.001,7.03,3.145,7.031,7.027c0,0.001,0,0.003,0,0.004
                c0.001,3.882-3.145,7.03-7.027,7.031c-0.001,0-0.003,0-0.004,0c-3.882,0.001-7.03-3.145-7.031-7.027
                C8.969,16.003,8.969,16.001,8.969,16z"/>
            </g>
          </svg>
          </template>
          <template v-else-if="task.contentType === 8">
            <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                 viewBox="0 0 32 32" style="enable-background:new 0 0 32 32;" xml:space="preserve">
            <g>
              <circle class="st0" cx="16" cy="16" r="16"/>
              <path id="file-pdf" class="st1" d="M22.254,10.446L19.3,7.496c-0.315-0.318-0.744-0.498-1.192-0.5h-7.17
                    c-0.934,0.003-1.69,0.762-1.688,1.696v14.625c0.001,0.932,0.756,1.687,1.688,1.687h10.125c0.931-0.001,1.686-0.756,1.687-1.687
                    V11.641C22.749,11.193,22.57,10.763,22.254,10.446z M20.925,11.504H18.25V8.829L20.925,11.504z M10.938,23.317V8.692h5.625v3.656
                    c-0.001,0.465,0.375,0.843,0.84,0.844c0.001,0,0.003,0,0.004,0h3.656v10.125H10.938z M19.738,18.265
                    c-0.438-0.422-1.657-0.311-2.268-0.229c-0.609-0.374-1.067-0.95-1.294-1.628c0.211-0.634,0.276-1.307,0.19-1.969
                    c-0.054-0.43-0.446-0.734-0.876-0.68c-0.277,0.035-0.515,0.215-0.624,0.473c-0.105,0.795-0.02,1.603,0.248,2.359
                    c-0.37,0.893-0.785,1.766-1.244,2.616c-0.7,0.362-1.652,0.921-1.793,1.624c-0.116,0.555,0.914,1.941,2.675-1.1
                    c0.782-0.293,1.584-0.529,2.4-0.707c0.602,0.343,1.272,0.548,1.962,0.6c0.448,0.011,0.821-0.343,0.832-0.792
                    c0.005-0.209-0.071-0.413-0.212-0.567H19.738z M12.769,21c0.273-0.476,0.636-0.893,1.069-1.23
                    C13.17,20.834,12.769,21.024,12.769,21z M15.638,14.3c0.26,0,0.236,1.129,0.063,1.434c-0.139-0.466-0.161-0.959-0.063-1.435V14.3z
                     M14.78,19.1c0.338-0.618,0.628-1.26,0.868-1.922c0.26,0.487,0.621,0.912,1.059,1.248C16.047,18.595,15.402,18.821,14.78,19.1
                    L14.78,19.1z M19.407,18.924c0,0-0.176,0.212-1.307-0.27C19.329,18.56,19.533,18.841,19.407,18.924L19.407,18.924z"/>
            </g>
          </svg>
          </template>
          <template v-else-if="task.contentType === 9">
            <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                 viewBox="0 0 32 32" style="enable-background:new 0 0 32 32;" xml:space="preserve">
            <g>
              <circle class="st0" cx="16" cy="16" r="16"/>
              <path id="file-alt" class="st1" d="M19.375,15.719c-0.001-0.234-0.19-0.423-0.424-0.422H18.95h-5.9
                    c-0.233,0.001-0.421,0.189-0.422,0.422v0.984c0.001,0.233,0.189,0.421,0.422,0.422h5.9c0.233-0.001,0.421-0.189,0.422-0.422
                    L19.375,15.719z M18.95,18.25h-5.9c-0.233,0.001-0.421,0.189-0.422,0.422v0.984c0.001,0.233,0.189,0.421,0.422,0.422h5.9
                    c0.233-0.001,0.421-0.189,0.422-0.422v-0.984C19.371,18.439,19.183,18.251,18.95,18.25z M22.75,11.637
                    c-0.002-0.446-0.182-0.873-0.5-1.187L19.3,7.5c-0.315-0.318-0.744-0.498-1.192-0.5h-7.17C10.006,7,9.25,7.756,9.25,8.688v14.625
                    C9.251,24.245,10.006,25,10.938,25h10.125c0.931-0.001,1.686-0.756,1.687-1.687V11.637z M18.25,8.825l2.675,2.675H18.25V8.825z
                     M21.063,23.313H10.938V8.688h5.625v3.656c-0.001,0.465,0.375,0.843,0.84,0.844c0.001,0,0.003,0,0.004,0h3.656V23.313z"/>
            </g>
          </svg>
          </template>
          <template v-else-if="task.contentType === 10">
            <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                 viewBox="0 0 32 32" style="enable-background:new 0 0 32 32;" xml:space="preserve">
            <g>
              <circle class="st0" cx="16" cy="16" r="16"/>
              <g>
                <path class="st1" d="M24.438,7H7.563C6.631,7,5.875,7.756,5.875,8.688v11.25c0.001,0.932,0.756,1.687,1.688,1.687h6.75
                    l-0.563,1.688h-2.531c-0.466,0-0.844,0.378-0.844,0.844S10.753,25,11.219,25h9.563c0.466-0.016,0.831-0.407,0.814-0.872
                    c-0.015-0.443-0.371-0.799-0.814-0.814H18.25l-0.562-1.687h6.75c0.932-0.001,1.688-0.757,1.687-1.689V8.688
                    C26.125,7.756,25.37,7.001,24.438,7z M23.875,19.375H8.125V9.25h15.75V19.375z"/>
                <path class="st1" d="M10.875,13.25h9c0.276,0,0.5-0.224,0.5-0.5v-1c0-0.276-0.224-0.5-0.5-0.5h-9c-0.276,0-0.5,0.224-0.5,0.5v1
                    C10.375,13.026,10.599,13.25,10.875,13.25z"/>
                <path class="st1" d="M10.875,17.25h6c0.276,0,0.5-0.224,0.5-0.5v-1c0-0.276-0.224-0.5-0.5-0.5h-6c-0.276,0-0.5,0.224-0.5,0.5v1
                    C10.375,17.025,10.599,17.25,10.875,17.25z"/>
              </g>
            </g>
          </svg>
          </template>
          <template v-else-if="task.contentType === 11">
            <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                 viewBox="0 0 32 32" style="enable-background:new 0 0 32 32;" xml:space="preserve">
            <g>
              <circle class="st0" cx="16" cy="16" r="16"/>
              <g>
                <path class="st1" d="M17.7,14.421h-5.9c-0.233,0.001-0.421,0.189-0.422,0.422v0.984c0.001,0.233,0.189,0.421,0.422,0.422h5.514
                    c0.245-0.097,0.498-0.177,0.76-0.236c0.028-0.057,0.048-0.118,0.048-0.186l0.003-0.984C18.124,14.609,17.935,14.42,17.7,14.421
                    C17.701,14.421,17.7,14.421,17.7,14.421z"/>
                <path class="st1" d="M11.378,17.796v0.984c0.001,0.233,0.189,0.421,0.422,0.422h2.571c0.272-0.693,0.68-1.316,1.203-1.828H11.8
                    C11.567,17.375,11.379,17.563,11.378,17.796z"/>
                <path class="st1" d="M9.688,22.437V7.812h5.625v3.656c-0.001,0.465,0.375,0.843,0.84,0.844c0.001,0,0.003,0,0.004,0h3.656v3.62
                    c0.599,0.067,1.166,0.225,1.687,0.477v-5.648c-0.002-0.446-0.182-0.873-0.5-1.187l-2.95-2.95c-0.315-0.318-0.744-0.498-1.192-0.5
                    h-7.17C8.756,6.124,8,6.88,8,7.812v14.625c0.001,0.932,0.756,1.687,1.688,1.687h5.28c-0.356-0.503-0.615-1.074-0.776-1.687H9.688z
                     M17,7.949l2.675,2.675H17V7.949z"/>
                <path class="st1" d="M23.891,24.791l-1.558-1.558c-0.071-0.07-0.166-0.109-0.266-0.109h-0.254c0.447-0.571,0.689-1.275,0.688-2
                    c0.001-1.794-1.454-3.249-3.248-3.25c-0.001,0-0.002,0-0.003,0c-1.794-0.001-3.249,1.454-3.25,3.248c0,0.001,0,0.001,0,0.002
                    c-0.001,1.794,1.454,3.249,3.248,3.25c0.001,0,0.001,0,0.002,0c0.725,0.002,1.429-0.24,2-0.687v0.255
                    c0,0.1,0.039,0.195,0.109,0.266l1.558,1.557c0.145,0.146,0.381,0.147,0.528,0.003c0.001-0.001,0.002-0.002,0.003-0.003
                    l0.442-0.443C24.035,25.176,24.036,24.939,23.891,24.791z M19.25,23.124c-1.105,0-2-0.895-2-2s0.895-2,2-2s2,0.895,2,2
                    S20.355,23.124,19.25,23.124z"/>
              </g>
            </g>
          </svg>
          </template>
        </div>
        <h1 class="task-single-header-title">
          {{ task.title }}
        </h1>
        <div class="task-single-header-meta-container">
          <div class="task-single-header-key">
            {{ task.key }}
          </div>
          <div class="task-single-header-chapter"
               v-if="getChapterById(task.chapter)">
            <div class="task-single-header-chapter-progress">
              <div class="task-single-header-chapter-image" v-bind:style="{backgroundImage: getChapterBackground(getChapterById(task.chapter)) }"></div>
              <svg class="progress" width="130" height="130" viewBox="0 0 100 100">
                <circle class="progress_meter" cx="50" cy="50" r="44" stroke-width="5"/>
                <circle class="progress_value"
                        :class="'filters_progress_value-' + getChapterById(task.chapter)['id']"
                        cx="50" cy="50" r="44"
                        v-if="getUserRole !== 'ta' && getUserRole !== 'tu'"
                        stroke-width="5"/>
              </svg>
            </div>
            <div class="task-single-header-chapter-name">{{ getChapterById(task.chapter)['name'] }}</div>
          </div>
          <div class="task-single-header-meta">
            <div class="task-single-header-meta-properties">
              <div class="task-single-header-meta-property recurrency" v-if="task.recurrent">
                <svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="sync-alt"
                     class="svg-inline--fa fa-sync-alt fa-w-16"
                     role="img" xmlns="http://www.w3.org/2000/svg"
                     viewBox="0 0 512 512">
                  <path fill="currentColor" d="M370.72 133.28C339.458 104.008 298.888 87.962 255.848 88c-77.458.068-144.328
                            53.178-162.791 126.85-1.344 5.363-6.122 9.15-11.651 9.15H24.103c-7.498 0-13.194-6.807-11.807-14.176C33.933
                            94.924 134.813 8 256 8c66.448 0 126.791 26.136 171.315 68.685L463.03 40.97C478.149 25.851 504 36.559 504
                            57.941V192c0 13.255-10.745 24-24 24H345.941c-21.382 0-32.09-25.851-16.971-40.971l41.75-41.749zM32 296h134.059c21.382
                            0 32.09 25.851 16.971 40.971l-41.75 41.75c31.262 29.273 71.835 45.319 114.876 45.28 77.418-.07 144.315-53.144
                            162.787-126.849 1.344-5.363 6.122-9.15 11.651-9.15h57.304c7.498 0 13.194 6.807 11.807 14.176C478.067 417.076 377.187
                            504 256 504c-66.448 0-126.791-26.136-171.315-68.685L48.97 471.03C33.851 486.149 8 475.441 8 454.059V320c0-13.255 10.745-24 24-24z"></path>
                </svg>
              </div>
              <div class="task-single-header-meta-property mandatory" v-if="task.mandatory">
                <svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="exclamation-circle"
                     class="svg-inline--fa fa-exclamation-circle fa-w-16"
                     role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                  <path fill="currentColor" d="M504 256c0 136.997-111.043 248-248 248S8 392.997 8 256C8 119.083 119.043 8 256 8s248
                            111.083 248 248zm-248 50c-25.405 0-46 20.595-46 46s20.595 46 46 46 46-20.595 46-46-20.595-46-46-46zm-43.673-165.346l7.418
                            136c.347 6.364 5.609 11.346 11.982 11.346h48.546c6.373 0 11.635-4.982 11.982-11.346l7.418-136c.375-6.874-5.098-12.654-11.982-12.654h-63.383c-6.884
                            0-12.356 5.78-11.981 12.654z"></path>
                </svg>
              </div>
            </div>
            <div class="task-single-header-meta-user-info">
<!--              <div class="task-single-header-meta-user priority"-->
<!--                   v-bind:class="['priority-' + taskPriorityDelta(task.score)]">-->
<!--                <svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="arrow-up"-->
<!--                     class="svg-inline&#45;&#45;fa fa-arrow-up fa-w-14" role="img"-->
<!--                     xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">-->
<!--                  <path fill="currentColor" d="M34.9 289.5l-22.2-22.2c-9.4-9.4-9.4-24.6 0-33.9L207 39c9.4-9.4 24.6-9.4 33.9 0l194.3 194.3c9.4 9.4 9.4 24.6-->
<!--                            0 33.9L413 289.4c-9.5 9.5-25 9.3-34.3-.4L264 168.6V456c0 13.3-10.7 24-24 24h-32c-13.3 0-24-10.7-24-24V168.6L69.2 289.1c-9.3 9.8-24.8 10-34.3.4z"></path>-->
<!--                </svg>-->
<!--                <span>{{ taskPriorityLabelByValue(taskPriorityDelta(task.score)) }}</span>-->
<!--              </div>-->
            </div>
          </div>
        </div>
      </div>
      <div class="task-single-body">
        <div class="task-single-body-content"
             v-bind:class="{collapsed: isSectionCollapsed('activeContent')}">
          <button class="task-single-collapse"
                  @click="collapseSection('activeContent')"
                  v-bind:class="{collapsed: isSectionCollapsed('activeContent')}">
            Task content
            <span class="task-single-collapse-arrow">
              <svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="chevron-down"
                   class="svg-inline--fa fa-chevron-down fa-w-14" role="img" xmlns="http://www.w3.org/2000/svg"
                   viewBox="0 0 448 512">
                <path fill="currentColor" d="M207.029 381.476L12.686 187.132c-9.373-9.373-9.373-24.569 0-33.941l22.667-22.667c9.357-9.357
                    24.522-9.375 33.901-.04L224 284.505l154.745-154.021c9.379-9.335 24.544-9.317 33.901.04l22.667 22.667c9.373 9.373 9.373 24.569
                    0 33.941L240.971 381.476c-9.373 9.372-24.569 9.372-33.942 0z"></path>
              </svg>
            </span>
          </button>
          <task-content v-bind:company="company"
                        v-bind:task-id="task.id"
                        v-bind:task-image="task.image"
                        v-bind:task-image-alt="task.imageAlt"
                        v-bind:task-content="task.content"
                        v-bind:task-resources="task.resources"
                        v-bind:task-content-type="task.contentType"
                        v-bind:task-title="task.title"></task-content>
        </div>
        <div class="task-single-body-data"
             v-bind:class="{collapsed: isSectionCollapsed('activeHistory')}">
          <button class="task-single-collapse"
                  @click="collapseSection('activeHistory')"
                  v-bind:class="{collapsed: isSectionCollapsed('activeHistory')}">
            Manage task
            <span class="task-single-collapse-arrow">
              <svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="chevron-down"
                   class="svg-inline--fa fa-chevron-down fa-w-14" role="img" xmlns="http://www.w3.org/2000/svg"
                   viewBox="0 0 448 512">
                <path fill="currentColor" d="M207.029 381.476L12.686 187.132c-9.373-9.373-9.373-24.569 0-33.941l22.667-22.667c9.357-9.357
                    24.522-9.375 33.901-.04L224 284.505l154.745-154.021c9.379-9.335 24.544-9.317 33.901.04l22.667 22.667c9.373 9.373 9.373 24.569
                    0 33.941L240.971 381.476c-9.373 9.372-24.569 9.372-33.942 0z"></path>
              </svg>
            </span>
          </button>
          <task-actions v-on:task-changed="taskChanged($event)"
                        v-bind:company="company"
                        v-bind:task-id="task.id"
                        v-bind:assignee="task.assignee"
                        v-bind:status="task.status"
                        v-bind:assessed="task.assessed"
                        v-bind:board="task.board"></task-actions>
          <task-history v-bind:company="company"
                        v-bind:task-id="task.id"
                        v-bind:new-status="newStatus"
                        v-bind:new-assignee="newAssignee"
                        v-bind:new-board="newBoard"></task-history>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
  import api from '@/api'
  import { mapGetters, mapActions } from 'vuex'
  import TaskHistory from './TaskHistory'
  import TaskContent from './TaskContent'
  import TaskActions from './TaskActions'

  export default {
    name: 'task-single',
    props: {
      company: Number
    },
    data () {
      return {
        taskId: null,
        task: null,
        newStatus: null,
        newAssignee: null,
        newBoard: null,
        previousRoute: null,
        activeContent: true,
        activeHistory: true,
        companies: []
      }
    },
    computed: {
      ...mapGetters([
        'getUserRole',
        'tasksPriorities',
        'taskStatuses',
        'taskStatusesForSelect',
        'taskChapters',
        'isAdmin'
      ]),
      currentCompany () {
        return this.companies.find((item) => item.value === this.company)
      }
    },
    methods: {
      ...mapActions([
        'getTaskChapters',
        'getTaskStatuses',
        'getTaskAssignee'
      ]),
      getChapterById (id) {
        return this.taskChapters.find((item) => item.id === id)
      },
      getChapterBackground (chapter) {
        if (this.selectedHightCont === 1) {
          return 'url(' + chapter.image_high + ')'
        } else {
          return 'url(' + chapter.image + ')'
        }
      },
      setChaptersProgress () {
        let self = this
        setTimeout(function () {
          self.taskChapters.forEach(function (chapter) {
            let score = chapter.score
            let selector = '.task-single .filters_progress_value-' + chapter.id
            self.setCompanyProgress(score, selector)
          })
        }, 1000)
      },
      setCompanyProgress (value, selector) {
        let RADIUS = 44
        let CIRCUMFERENCE = 2 * Math.PI * RADIUS
        let progressValue = document.querySelectorAll(selector)
        if (progressValue.length) {
          for (let i = 0; i < progressValue.length; i++) {
            let progress = value / 100
            if (progressValue[i]) {
              progressValue[i].style.opacity = 1
              progressValue[i].style.strokeDasharray = CIRCUMFERENCE
              progressValue[i].style.strokeDashoffset = CIRCUMFERENCE * (1 - progress)
            }
          }
        }
      },
      taskPriorityLabelByValue (value) {
        const priority = this.tasksPriorities.find((item) => item.value === value)
        return priority ? priority.label : ''
      },
      taskPriorityDelta (value) {
        let priorityDelta = 0
        if (value <= 33) {
          priorityDelta = 0
        } else if (value > 33 && value <= 66) {
          priorityDelta = 1
        } else if (value > 66 && value <= 100) {
          priorityDelta = 2
        }
        return priorityDelta
      },
      getTaskById () {
        let actionURL = `${api.URLS.task}/browse/${this.taskId}`
        if (this.company) {
          actionURL += `?company=${this.company}`
        }
        this.$http.get(actionURL, api.headersAuthSettings).then((res) => {
          this.task = res.body
          document.title = this.task.title + ' | Clear Assured'
          if (window._paq) {
            window._paq.push(['setCustomUrl', location.pathname])
            window._paq.push(['setDocumentTitle', document.title])
            window._paq.push(['trackPageView'])
          }
          // if (window.ga) {
          //   window.ga('set', 'contentGroup1', 'TASK')
          //   window.ga('send', 'pageview', {
          //     'page': location.pathname,
          //     'location': location.href,
          //     'title': document.title
          //   })
          // }
        }).catch((err) => {
          if (err.status === 404) {
            let props = this.$router.resolve({
              name: 'no-permissions'
            })
            this.$router.push(props.href)
          }
        })
      },
      taskChanged (event) {
        if (event.hasOwnProperty('status')) {
          this.newStatus = event.status
        }
        if (event.hasOwnProperty('assignee')) {
          this.newAssignee = event.assignee
        }
        if (event.hasOwnProperty('board')) {
          this.newBoard = event.board
        }
        this.getTaskById()
      },
      isSectionCollapsed (section) {
        return this[section] === false
      },
      collapseSection (section) {
        this[section] = !this[section]
      },
      changeCompany (event) {
        if (event.value === this.company) {
          return
        }
        let props = this.$router.resolve({
          name: 'company-task',
          params: {
            companyId: event.value,
            id: this.taskId
          }
        })
        // this.$router.push(props.href)
        location.href = props.href
      },
      getAllCompaniesForSelect () {
        this.$http.get(`${api.URLS.companiesS}/all/select`, api.headersAuthSettings)
          .then((res) => {
            this.companies = res.body
          }).catch(() => {})
      }
    },
    beforeMount () {
      this.getTaskChapters(this.company)
      this.getTaskStatuses(this.company)
      this.getTaskAssignee(this.company)
    },
    created () {
      this.taskId = parseInt(this.$route.params.id)
      this.getTaskById()
      if (this.isAdmin) {
        this.getAllCompaniesForSelect()
      }
    },
    components: {
      TaskActions,
      TaskContent,
      TaskHistory
    },
    watch: {
      '$route' (to, from) {
        if (to.params.id !== from.params.id) {
          this.taskId = parseInt(to.params.id)
          this.getTaskById()
        }
        if (to.params.companyId !== from.params.companyId) {
          this.taskId = parseInt(to.params.id)
          this.getTaskById()
        }
      },
      taskChapters (value) {
        if (value) {
          this.setChaptersProgress()
        }
      }
    },
    beforeRouteEnter (to, from, next) {
      next(vm => {
        vm.prevRoute = from
      })
    }
  }
</script>

<style src="@/assets/scss/components/tasks/task-single.scss" lang="scss" scoped />



// WEBPACK FOOTER //
// TaskSingle.vue?e8cf267c